import { render } from "./BannerSlotDetailBannerLibrary.vue?vue&type=template&id=3b2ea95b&ts=true"
import script from "./BannerSlotDetailBannerLibrary.vue?vue&type=script&lang=ts"
export * from "./BannerSlotDetailBannerLibrary.vue?vue&type=script&lang=ts"

import exportComponent from "/var/lib/jenkins/workspace/bouwstenen/Bouwsteen_BuildAndDeploy_Vue_Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__